export const ILLEGAL_AGE_PATH = '/illegal';
